import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../api";
import axios from "axios";

const initialState = {
  list: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const cronJobSlice = createSlice({
  name: "cronJob",
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getCronJobs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCronJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.cronJobs;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getCronJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getCronJobs = createAsyncThunk(
  "cronJobSlice/getCronJobs",
  async ({ currentPage, pageSize, q }) => {
    try {
      const { url, method, headers } = api.getCronJobs(
        currentPage,
        pageSize,
        q
      );
      const cronJobs = await axios({
        url,
        method,
        headers,
      });
      return cronJobs.data;
    } catch (error) {
      return error.message;
    }
  }
);

export default cronJobSlice.reducer;
